import { Component, computed, input } from '@angular/core';
import { InfoHintComponent } from '../../shared/design-system/info-hint.component';

@Component({
  standalone: true,
  selector: 'ain-inventory-page-hint',
  imports: [InfoHintComponent],
  template: `
    <ain-info-hint page-title-addon
      [titleKey]="titleKey()"
      [descriptionKey]="descriptionKey()"
      [bulletKeys]="bulletKeys()" />
  `
})
export class InventoryPageHintComponent {
  readonly pageKey = input.required<string>();

  readonly titleKey = computed(() => `catalog.inventory.help.${this.pageKey()}.title`);
  readonly descriptionKey = computed(() => `catalog.inventory.help.${this.pageKey()}.description`);
  readonly bulletKeys = computed(() => [
    `catalog.inventory.help.${this.pageKey()}.bullet1`,
    `catalog.inventory.help.${this.pageKey()}.bullet2`
  ]);
}
